export const ENABLE_WEB_INTERFACE = process.env.NEXT_PUBLIC_ENABLE_WEB_INTERFACE === 'true';
